import { V4 } from '@moleculeone/utils';
import { styled } from '../../../../stitches.config';

const SVGGroup = styled('g');

function Part(props: any) {
  const { textPart, targetPosition, ...restProps } = props;

  const cornerPosition = V4.add(targetPosition, textPart.shift, V4.mul(textPart.size, V4.vect(-0.5, -0.5)));

  return (
    <rect
      x={cornerPosition[0].toFixed(2)}
      y={cornerPosition[1].toFixed(2)}
      width={textPart.size[0].toFixed(2)}
      height={textPart.size[1].toFixed(2)}
      {...restProps}
    />
  );
}

export function AtomBackground(props: any) {
  const { color, center, side, pos, rectProps = {}, ...restProps } = props;

  const result = center.parts.map((part: any, i: number) => (
    <Part textPart={part} targetPosition={pos} key={String(i)} {...rectProps} />
  ));

  if (side) {
    result.push(
      ...side.parts.map((part: any, i: number) => {
        const sidePos = V4.add(pos, side.shift);

        return <Part textPart={part} targetPosition={sidePos} key={String(i + center.parts.length)} {...rectProps} />;
      })
    );
  }

  return (
    <SVGGroup stroke="none" fill={color} fillOpacity="1" {...restProps}>
      {result}
    </SVGGroup>
  );
}
